import React from 'react'

import Loading from 'components/libs/loading/Loading'
import { useBccOAuth2CallbackLogic } from 'components/pages/bccOAuth2/useBccOAuth2CallbackLogic'

function BccOAuth2Callback() {
  useBccOAuth2CallbackLogic()

  return <Loading />
}

export default BccOAuth2Callback
